
export default {
  props: {
    page: {
      default: 1,
    },
    pages: {
      default: 1,
    },
    ulClass: {
      default: "pagination",
    },
    liClass: {
      default: "page-item",
    },
    aClass: {
      default: "page-link",
    },
    nextText: {
      default: ">",
    },
    prevText: {
      default: "<",
    },
  },
  methods: {
    SET_PAGINATION(page) {
      this.$emit("change", page);
    },
  },
};
